import type { SxProps, Theme } from '@mui/material';

export const aboutDeckCardSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  opacity: 0.8,
};

export const aboutDeckTitleSx: SxProps<Theme> = {
  mb: 2,
};

export const aboutDeckListSx: SxProps<Theme> = {
  pl: 2,
  mb: 2,
  '& li': { mb: 1 },
};

export const aboutDeckBodyTextSx: SxProps<Theme> = {
  opacity: 0.8,
};
